import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PermissionsService } from 'shared-lib';

@Component({
  selector: 'app-settings-sidenav',
  templateUrl: './settings-sidenav.component.html',
  styleUrl: './settings-sidenav.component.scss',
  standalone: false
})
export class SettingsSidenavComponent implements OnInit{
  collapsed: boolean = false;
  activeRoute: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
     public permissionService: PermissionsService
  ) {}

  ngOnInit(): void {
    const url = this.router.url.split('?')[0];
    const segments = url.split('/');
    
    const index = segments.indexOf('settings');
    if (index !== -1 && index + 1 < segments.length) {
      this.activeRoute = segments[index + 1];
    }
  }

  toggleSidebar() {
    this.collapsed = !this.collapsed;
  }

  navigate(route: string) {

    if (route == '' || route == undefined) {
      this.toastr.info('Not implemented yet!');
    } else {
      if (route.endsWith("/0")) 
        this.activeRoute = route.slice(0, -2); //to remove '/0'
      else
        this.activeRoute = route;

      this.router.navigate([route], { relativeTo: this.route });
    }

  }
}
